// extracted by mini-css-extract-plugin
export default {"headers":"layout_headers__-j6ZD","heading_title":"layout_heading_title__-L-dA","container":"layout_container__yPuof","content":"layout_content__IyIpJ"};